import { jsLazyLoad } from '../../utils/webComponent';

/**
 * Sets a PeeriusCallbacks properties data
 * window.PeeriusCallbacks is required by Peerius
 * @param track the required tracking data for Peerius
 */
function setPeeriusCallbacks(track) {
    window.PeeriusCallbacks = { track, apiVersion: 'v1_4' }; // window.PeeriusCallbacks is required by Peerius
    Object.assign(window.PeeriusCallbacks.track, {
        recContent: 'refCodeOnly',
        smartRecs: { markRecsAsShown: false },
    });
}

/**
 * Sends a request to peerius with the tracking data and gets recommendations in the response
 * by adapting old fashioned peerius API with global variables to the modern Promise-based.
 * This is a first request to the Peerius, that's going to be loaded only once.
 * It combines Tracking and Recommendations, all subsequent will send only Tracking
 * @param trackerUrl the url from where to load the peerius tracker script
 */
function loadPeeriusScript(trackerUrl) {
    jsLazyLoad(trackerUrl);
}

/**
 * Sends the tracking data to peerius.
 * Requests of this type are sent each time the cart is updated, the order, etc.
 * And only after the first type of requests is sent
 * @param clientName
 * @param type
 * @param track
 */
function sendCartTracking(clientName, type, track) {
    const encodedTrack = encodeURIComponent(JSON.stringify(track[type]));
    window.Peerius.sendAjax(`${clientName}/${type}/add.pagex?${type}=${encodedTrack}`);
}

function sendImpressionsForCarousel(clientName, selectedRecommendations) {
    window.Peerius.sendAjax(
        `${clientName}/rec/shown.pagex?ids=${selectedRecommendations.join(',')}`,
    );
}

function sendClick(id, takesToANewPage) {
    let actualMethod;
    if (takesToANewPage) {
        actualMethod = 'smartRecsClick';
    } else {
        actualMethod = 'smartRecsSendClick';
    }
    window.Peerius[actualMethod](id);
}
function sendContentClick(id) {
    window.Peerius.smartContentClick(id);
}

export default {
    setPeeriusCallbacks,
    loadPeeriusScript,
    sendCartTracking,
    sendImpressionsForCarousel,
    sendClick,
    sendContentClick,
};
